import {FC} from "react";
import {Form, Formik} from "formik";
import {
    BaseInfoBlock,
    BonusCodeFormValues,
    RewardBlock,
    UsesListBlock
} from "./forms";
import {Col, Row} from "react-bootstrap";
import {FormPageFooter, FormPageHeader} from "@components/falcon/common/forms";
import {ObjectSchema} from "yup";

interface BonusCodeFormProps {
    initial: BonusCodeFormValues;
    onSubmit: (values: BonusCodeFormValues) => any;
    validationSchema?: ObjectSchema<BonusCodeFormValues>;
    editForm?: boolean;
}

const BonusCodeForm: FC<BonusCodeFormProps> = ({initial, onSubmit, editForm, validationSchema}) => {

    const title = editForm ? "Редактирование бонусного кода" : "Создание бонусного кода";

    return (
        <Formik
            initialValues={initial}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
        >
            <Form>
                <Row className="g-3">
                    <Col xs={12}>
                        <FormPageHeader title={title} />
                    </Col>
                    <Col lg={8}>
                        <BaseInfoBlock editForm={editForm} />
                    </Col>
                    <Col lg={4}>
                        <RewardBlock editForm={editForm} />
                        {editForm && (
                            <UsesListBlock />
                        )}
                    </Col>
                    <Col>
                        <FormPageFooter
                            cancelUrl="/consumer/bonuses/"
                        />
                    </Col>
                </Row>
            </Form>
        </Formik>
    )
}

export default BonusCodeForm;